const dropShadowControl = () => {
    const scroll = document.documentElement.scrollTop || window.scrollY;
    const siteHeader = document.querySelector(".site-header");

    if (scroll >= 100) {
        siteHeader?.classList.remove("no-drop-shadow");
    } else {
        siteHeader?.classList.add("no-drop-shadow");
    }
}


window.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', dropShadowControl);

    /* Fix - Scroll up issue on subcription page */
    const subscriptionButtons = document.querySelectorAll(".subscription-center-page button.btn-submit");
    subscriptionButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            const options = document.querySelectorAll('.subscription-center-page .js-form .InvestorType option');
            
            options.forEach(option => {
                if (option.value === "" && option.hasAttribute('selected')) {
                    window.setTimeout(function () {
                        const subscribeBlock = document.querySelector(".subscribe-block");
                        if (subscribeBlock) {
                            const offsetTop = subscribeBlock.getBoundingClientRect().top + window.scrollY;
                            window.scrollTo({
                                top: offsetTop - 100,
                                behavior: 'smooth'
                            });
                        }
                    }, 50);
                }
            });
        });
    });

    // Smooth scrolling effect for the hyperlinks
    const smoothScrollLinks = document.querySelectorAll('main a[href^="#"], section a[href^="#"], header.header-new a[href^="#"]');
    smoothScrollLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            if (this.getAttribute('href') === "#") return false;
            
            const targetElement = document.querySelector(this.getAttribute('href'));
            if (targetElement) {
                const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: offsetTop - 110,
                    behavior: 'smooth'
                });
            }
            return false;
        });
    });

    /**
     * Mega-menu event handler to prevent being overridden by a dropdown.
     */
    const navItems = document.querySelectorAll("li.site-header__nav-item.nav-item");
    navItems.forEach(item => {
        item.addEventListener('mouseenter', function () {
            const dropdownMenus = document.querySelectorAll(".dropdown-menu.show");
            dropdownMenus.forEach(menu => menu.classList.remove("show"));
            
            const dropdowns = document.querySelectorAll(".dropdown.show, .dropdown-checkbox.show");
            dropdowns.forEach(dropdown => dropdown.classList.remove("show"));
        });
    });
});

function updatePageVistCountOnLocalStorage() {
    let pageVisitCount = localStorage.getItem("ve-PageVisitCount-eu");
    if (pageVisitCount) {
        pageVisitCount = parseInt(pageVisitCount) + 1;
    } else {
        // If gateway modal is open, ignore the page visit
        const gatewayModal = document.getElementById("gateway-modal");
        if (gatewayModal && gatewayModal.classList.contains("show")) return;
        pageVisitCount = 1;
    }

    const pageVisitsTracked = localStorage.getItem("ve-pagevisits-eu");
    if (!pageVisitsTracked) {
        pageVisitCount = 1;
    }
    localStorage.setItem("ve-PageVisitCount-eu", pageVisitCount);
}

window.addEventListener("DOMContentLoaded", updatePageVistCountOnLocalStorage);

/*
* Sticky back-to-top
*/
window.stickyBackToTop = {
    init: function () {
        const backToTopButton = document.querySelector('#back-to-top-wrapper > .back-to-top');
        if (!backToTopButton) return;

        const height = window.innerHeight / 4;

        window.addEventListener('scroll', function () {
            if (window.scrollY > height) {
                backToTopButton.style.display = 'block';
            } else {
                backToTopButton.style.display = 'none';
            }
        });
    }
};

window.addEventListener('DOMContentLoaded', function () {
    stickyBackToTop.init();
});

//
/*** Menu and AHP-related code ***/
/*** These are a duplicate of static/js/header/header-override.js
*      Make sure they are modified there too! ***/

/*** converts a bs4 tab-nav to render on hover vs click ***/
function hoverfytabs(selector, hoverblock) {
    hoverblock = (!hoverblock) ? false : hoverblock;
    
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
        // Activates on click, not hover
        element.addEventListener('click', function () {
            if (this.classList.contains('hoverblock')) return;
            
            // Force remove everything else
            const activeTab = this.parentElement.querySelector('a.active');
            const targettedTabGroup = activeTab?.dataset.target;
            
            if (targettedTabGroup) {
                const tabContent = document.querySelector(targettedTabGroup);
                if (tabContent) {
                    const activeTabs = tabContent.parentElement.querySelectorAll('.active.show');
                    activeTabs.forEach(tab => {
                        tab.classList.remove('active');
                        tab.classList.remove('show');
                    });
                }
            }
            
            const allTabs = this.parentElement.querySelectorAll('a');
            allTabs.forEach(tab => {
                tab.classList.remove('active');
                tab.classList.remove('show');
            });
            
            // Bootstrap tab functionality - may need additional implementation
            const tab = this.querySelector('a');
            if (tab) {
                // Simulate Bootstrap's tab('show')
                tab.classList.add('active');
                
                // Get the target from href or data-target
                const target = tab.getAttribute('data-target') || tab.getAttribute('href');
                if (target) {
                    const targetElement = document.querySelector(target);
                    if (targetElement) {
                        const parentTabContent = targetElement.closest('.tab-content');
                        if (parentTabContent) {
                            const tabPanes = parentTabContent.querySelectorAll('.tab-pane');
                            tabPanes.forEach(pane => {
                                pane.classList.remove('active', 'show');
                            });
                        }
                        targetElement.classList.add('active', 'show');
                    }
                }
            }
        });
    });
    
    if (hoverblock === true) {
        elements.forEach(element => {
            const links = element.querySelectorAll('a');
            links.forEach(link => {
                link.addEventListener('click', function () {
                    const siblings = Array.from(this.parentElement.parentElement.children);
                    siblings.forEach(sibling => {
                        if (sibling !== this.parentElement) {
                            sibling.classList.add('hoverblock');
                        }
                    });
                });
            });
        });
    }
}

// Focus on searchbox once the user clicks search
function focusOnSearchBox() {
    const searchModal = document.getElementById('site-header-search');
    if (searchModal) {
        // Bootstrap modal event - may need different approach
        searchModal.addEventListener('shown.bs.modal', function () {
            const searchInput = document.querySelector('input.search__input');
            if (searchInput) {
                searchInput.focus();
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    focusOnSearchBox();

    /* Adds a class to the dynamic modal backdrop so we can style it as needed. */
    const searchBackdropClass = "bs4-search-backdrop";
    const searchModal = document.getElementById('site-header-search');
    
    if (searchModal) {
        // Bootstrap modal events - may need alternative approach
        searchModal.addEventListener('shown.bs.modal', function () {
            const modalBackdrops = document.querySelectorAll('.modal-backdrop');
            modalBackdrops.forEach(backdrop => {
                backdrop.classList.add(searchBackdropClass);
            });
        });
        
        searchModal.addEventListener('hidden.bs.modal', function () {
            const modalBackdrops = document.querySelectorAll('.modal-backdrop');
            modalBackdrops.forEach(backdrop => {
                backdrop.classList.add(searchBackdropClass);
            });
        });
    }

    /* Navigates to the search page once you press enter on the search bar. */
    const searchInputs = document.querySelectorAll(".form-control.search__input");
    searchInputs.forEach(input => {
        input.addEventListener('keyup', function (e) {
            if (e.which === 13) {
                window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(e.currentTarget.value));
            }
        });
    });

    /**
     * Remove and replace all of the submenu items to remove all eventlistners added by VShift.
     * This is replaced by our own hover function below.
     * Done so we can keep their scripts.js file intact.
     */
    const submenuActions = document.querySelectorAll('.site-header__submenu-action');
    submenuActions.forEach(element => {
        const elClone = element.cloneNode(true);
        element.parentNode.replaceChild(elClone, element);
    });

    /** Non-investment submenu items --> make sure they are activated on hover. */
    const submenuItems = document.querySelectorAll('.site-header__submenu .site-header__submenu-action.list-group-item');
    submenuItems.forEach(item => {
        item.addEventListener('mouseenter', function () {
            // Get the data values
            const menu = this.dataset.menu;
            const targetPane = this.dataset.default;
            
            if (menu) {
                // Make this active
                const menuActions = document.querySelectorAll(`.site-header__submenu#${menu} .site-header__submenu-action.list-group-item`);
                menuActions.forEach(action => {
                    action.classList.remove('active', 'show');
                });
                
                this.classList.add('active', 'show');
                
                // Toggle the actual menu now
                const menuElement = document.getElementById(menu);
                if (menuElement) {
                    const tabPanes = menuElement.querySelectorAll(".tab-content > .tab-pane");
                    tabPanes.forEach(pane => {
                        pane.classList.remove("active", "show");
                    });
                    
                    if (targetPane) {
                        const targetElement = document.getElementById(targetPane);
                        if (targetElement) {
                            targetElement.classList.add("active", "show");
                        }
                    }
                }
            }
        });
    });

    // Convert the megamenu tabs in the investments section to work as tab on hover.
    hoverfytabs('.navbar .hover-tabs > .nav-tabs > li', false);
    // hoverfytabs('.bs4-nav .site-header__submenu-inner .list-group', false);
});